/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BehaviorSubject } from "rxjs";
import {
  IHeaderVisibilitySettings,
  IPracticeHeadInfo,
} from "../../models/interfaces";

/**
 * This component will eventually be pulled out in to a layout library. Currently, it only contains
 * work from Amelia trying to figure out what the API/interfaces should look like.
 *
 * A lot of this component should be reworked.
 */
@Component({
    selector: "ofi-foundation-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FoundationHeaderComponent implements OnInit, OnChanges {
  /** Maybe we'll store the state/configuration here? */
  headerData = new BehaviorSubject({
    username: undefined,
    visibility: {
      menuButton: false,
      user: false,
      translate: false,
      logo: true,
    },
    practice: undefined,
  });
  /** A template to use inside the sidebar. */
  // eslint-disable-next-line  @typescript-eslint/no-unsafe-function-type
  @Input() menuButtonCB?: Function;
  /** We're going to need to know practice information eventually. :x */
  @Input() practice?: IPracticeHeadInfo;
  /** The name that will appear next to the user icon. **The user's first name is recommended**. */
  @Input() username?: string;
  /** Which items should appear in the header. */
  @Input() visibility?: IHeaderVisibilitySettings;

  /** @ignore */
  constructor() {}

  /** @ignore */
  public ngOnChanges(changes: SimpleChanges): void {}

  /** @ignore */
  public ngOnInit(): void {}
}
